module.exports = __webpack_public_path__ + "img/banner-princiapal.1d5c979a.png";